import { purpose, states, practice_types } from '../data/data';

export default {
    "section": "Section 1: General Information",
    "name": "general",
    "items": [
        {
            "text": "Add people that you would like us to send the electronic version of the report to.",
            "type": "data-table",
            "name": "general-send-to-others",
            "props": {
                "headers": [
                    {
                        "text": "Full Name",
                        "value": "full-name"
                    },
                    {
                        "text": "Email",
                        "value": "email"
                    }
                ],
                "newItemLabel": "Add Person",
                "noDataLabel": "Add People to Receive Report",
                "optional": true
            }
        },
        {
            "text": "In addition to the electronic version, would you like a hardcopy of the report?",
            "type": "radio-list",
            "name": "general-hardcopy",
            "props": {
                "items": [
                    {
                        "text": "Yes, send me a hardcopy",
                        "value": "yes"
                    },
                    {
                        "text": "No, PDF only",
                        "value": "no"
                    }
                ]
            },
            "subItems": [
                {
                    "text": "Address",
                    "type": "text-field",
                    "name": "general-hardcopy-address",
                    "props": {
                        "label": "Address"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "general-hardcopy",
                                "value": "yes"
                            }
                        ]
                    }
                },
                {
                    "text": "City",
                    "type": "text-field",
                    "name": "general-hardcopy-city",
                    "props": {
                        "label": "City"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "general-hardcopy",
                                "value": "yes"
                            }
                        ]
                    }
                },
                {
                    "text": "State",
                    "type": "selectlist",
                    "name": "general-hardcopy-state",
                    "props": {
                        "items": "swap-states",
                        "label": "Please select an option"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "general-hardcopy",
                                "value": "yes"
                            }
                        ]
                    }
                },
                {
                    "text": "Postal Code",
                    "type": "text-field",
                    "name": "general-hardcopy-postal",
                    "props": {
                        "label": "Postal Code"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "general-hardcopy",
                                "value": "yes"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Practice type (select all that apply)",
            "type": "checkbox-list",
            "name": "general-practice-type",
            "props": {
                "items": "swap-practice_types"
            }
        },
        {
            "text": "Niche business?",
            "type": "radio-list",
            "name": "general-niche",
            "props": {
                "items": [
                    {
                        "text": "Yes",
                        "value": "yes"
                    },
                    {
                        "text": "No",
                        "value": "no"
                    }
                ],
                "row": true
            },
            "subItems": [
                {
                    "text": "Please describe",
                    "type": "textarea",
                    "name": "general-niche-description",
                    "dependencies": {
                        "items": [
                            {
                                "name": "general-niche",
                                "value": "yes"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Unique Competitive Advantages?",
            "type": "radio-list",
            "name": "general-unique-competitive-advantage",
            "props": {
                "items": [
                    {
                        "text": "Yes",
                        "value": "yes"
                    },
                    {
                        "text": "No",
                        "value": "no"
                    }
                ],
                "row": true
            },
            "subItems": [
                {
                    "text": "Please describe",
                    "type": "textarea",
                    "name": "unique-competitive-advantage-description",
                    "dependencies": {
                        "items": [
                            {
                                "name": "general-unique-competitive-advantage",
                                "value": "yes"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Describe the services you provide.",
            "type": "textarea",
            "name": "general-describe-services"
        },
        {
            "text": "Purpose of Valuation?",
            "type": "selectlist",
            "name": "general-purpose",
            "props": {
                "items": [],
                "label": "Please select an option"
            },
            "subItems": [
                {
                    "text": "Please describe the other purpose",
                    "type": "textarea",
                    "name": "general-purpose-description",
                    "dependencies": {
                        "items": [
                            {
                                "name": "general-purpose",
                                "value": "I have another purpose"
                            }
                        ]
                    }
                },
                {
                    "text": "Secondary Purpose of Valuation?",
                    "type": "selectlist",
                    "name": "general-secondary-purpose",
                    "props": {
                        "items": [],
                        "label": "Please select a secondary purpose"
                    },
                },
                {
                    "text": "Additional Purpose of Valuation?",
                    "type": "selectlist",
                    "name": "general-additional-purpose",
                    "props": {
                        "items": [],
                        "label": "Please select an additional purpose"
                    }
                }
            ]
        },
        {
            "text": "Have you previously had a valuation completed?",
            "type": "radio-list",
            "name": "general-previous-valuation",
            "props": {
                "items": [
                    {
                        "text": "Yes",
                        "value": "yes"
                    },
                    {
                        "text": "No",
                        "value": "no"
                    }
                ],
                "row": true
            }
        },
        {
            "text": "Please include copies of all previous valuation reports when submitting your questionnaire.",
            "type": "data-table",
            "name": "general-previous-valuation-files",
            "props": {
                "headers": [
                    {
                        "text": "File Name",
                        "value": "filename"
                    },
                    {
                        "text": "File Size",
                        "value": "filesize"
                    }
                ],
                "isFileUpload": true,
                "newItemLabel": "Upload a File",
                "noDataLabel": "Please Upload Any Previous Valuations"
            },
            "dependencies": {
                "items": [
                    {
                        "name": "general-previous-valuation",
                        "value": "yes"
                    }
                ]
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/valuation/valuation-data/general.js